import { AnimatePresence } from 'framer-motion'
import { useMemo } from 'react'
import {
  SwitchCurrency,
  type SwitchCurrencyProps,
} from '@components/SwitchCurrency/SwitchCurrency'
import { SwitchStore } from '@velasca/ui/switch-store'
import * as S from './StoreSwitchPage.styles'

export const StoreSwitchPage = ({
  type,
  currencies,
  upperGap,
  opened,
  onClose,
}: {
  type: 'country' | 'currency'
  currencies?: SwitchCurrencyProps['currencies']
  upperGap: number
  opened: boolean
  onClose: () => void
}) => {
  const switchStoreElement = useMemo(() => {
    if (type === 'country') {
      return (
        <SwitchStore
          showTitle={false}
          showSearchBar={false}
          closeSectionHandler={onClose}
        />
      )
    }

    return (
      <SwitchCurrency
        currencies={currencies ?? []}
        closeSectionHandler={onClose}
      />
    )
  }, [currencies, onClose, type])

  return (
    <AnimatePresence>
      {opened && (
        <S.StoreSwitchPage
          upperGap={upperGap}
          transition={{ ease: 'easeOut', duration: 0.25 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{
            y: '100%',
            opacity: 0,
          }}
          initial={{
            y: '100%',
            opacity: 0,
          }}
        >
          {switchStoreElement}
        </S.StoreSwitchPage>
      )}
    </AnimatePresence>
  )
}
